const publicAccessToken = () => process.env.REACT_APP_PUBLIC_ACCESS_TOKEN || '';

export default publicAccessToken;
